<script setup lang="ts">
import cornerArrows from '@/assets/images/banner/window-size/corner-arrows-outward.svg';
</script>

<template>
	<div class="fixed top-0 left-0 z-90 flex size-full flex-col items-center justify-center bg-neutral-700 p-4">
		<div class="z-10 w-full max-w-xl min-w-fit">
			<div class="relative flex size-full min-h-fit min-w-fit flex-col rounded-3xl bg-white p-6">
				<!-- Modal body -->
				<div class="flex max-w-xl flex-col items-center justify-center p-4">
					<img :src="cornerArrows" alt="Resize your browser window" class="h-auto w-48" />

					<p class="mt-5 text-center text-xl font-bold text-Qblack-900">
						Your browser window is too small for our content.
					</p>
					<p class="mt-3 text-center text-base font-normal text-Qblack-900">
						Make your window larger by dragging the corners of the browser.
					</p>
					<p class="mt-3 text-center text-base font-normal text-Qblack-900">
						Need more help?
						<a
							href="https://help.qweebi.com/en/articles/11194267-why-do-i-see-the-message-your-browser-window-is-too-small-for-our-content"
							target="_blank"
							rel="noreferrer noopener"
							class="text-blue-500"
							>See this help article.</a
						>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
